import { API_URL } from '../constants';
import fetchAuthorization from './fetchAuthorization';
import { getErrorMessage } from '../helpers';
import { IPlayerProfile } from '../models/PlayerProfile';

export async function savePlayerProfile(newProfile: IPlayerProfile): Promise<IPlayerProfile> {
  try {
    const response = await fetchAuthorization(`${API_URL}player_profile?member_id=${newProfile.member_id}`, {
      headers: {
        'Content-Type': 'application/json',
      },
      method: 'PUT',
      body: JSON.stringify(newProfile),
    });

    const result = await response.json();

    if (response.status !== 200) {
      const message = getErrorMessage(result);
      throw new Error(message ? message : `Status Code: ${response.status}. Sorry, something went wrong. Please try again later.`);
    }

    return result;
  } catch (e: any) {
    throw new Error(`Unable to save Player Profile. ${e.message}`);
  }
}

export default savePlayerProfile;
